import React from 'react';

import {
	ApRadio,
	ApSimpleSearch,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import numeral from 'numeral';
import {
	Wrapper,
	Subtitle,
	RadioWrapper,
	RadioGroup,
	HelperText,
	RadioLabel,
	TextTruncate,
	LoaderWrapper,
} from './DimensionStep.styles';
import { isEqual } from 'lodash';

const VALUES_THRESHOLD = 20;

const DEFAULT_DIMENSION = { displayName: 'None', dimensionName: '' };

export class DimensionStep extends React.Component {
	state = {
		query: '',
		dimension: null,
	};

	componentDidMount() {
		this.setDefaultDimension();
	}

	componentDidUpdate(prevProps, prevState) {
		const { onDimensionChange } = this.props;
		const { dimension } = this.state;

		if (dimension && !isEqual(dimension, prevState.dimension)) {
			onDimensionChange(
				{
					dimension: dimension.dimensionName,
					displayName: dimension.displayName,
				},
				true
			);
		}
	}

	setDefaultDimension = () => {
		const { params } = this.props;

		const initialDimension =
			params && params.dimension
				? { displayName: params.displayName, dimensionName: params.dimension }
				: DEFAULT_DIMENSION;

		this.setState({ dimension: initialDimension });
	};

	setSearchQuery = query => {
		this.setState({ query });
	};

	changeDimension = item => {
		this.setState({ dimension: item });
	};

	getFilteredColumns = () => {
		const { query } = this.state;
		const { data } = this.props;

		if (!query) {
			return data;
		}

		return data.filter(item =>
			item.displayName.toLowerCase().includes(query.toLowerCase())
		);
	};

	getHighlightedName = name => {
		const { query } = this.state;

		if (!query) {
			return name;
		}

		const index = name.toLowerCase().indexOf(query.toLowerCase());
		const before = name.slice(0, index);
		const searchValue = name.slice(index, index + query.length);
		const after = name.slice(index + query.length, name.length);

		return (
			<React.Fragment>
				{before}
				<span>{searchValue}</span>
				{after}
			</React.Fragment>
		);
	};

	render() {
		const { dimension } = this.state;
		const { data } = this.props;

		return (
			<Wrapper>
				Break down spend by one additional dimension
				<Subtitle>
					Note, only dimensions with {VALUES_THRESHOLD} or fewer unique values
					can be selected
				</Subtitle>
				<ApSimpleSearch
					id="dimension-search"
					onChange={value => this.setSearchQuery(value)}
					onClear={() => this.setSearchQuery('')}
				/>
				<RadioGroup>
					<RadioWrapper>
						<ApRadio
							name="columns"
							value={DEFAULT_DIMENSION.dimensionName}
							checked={
								!!dimension &&
								DEFAULT_DIMENSION.dimensionName === dimension.dimensionName
							}
							onChange={() => this.changeDimension(DEFAULT_DIMENSION)}
						>
							{DEFAULT_DIMENSION.displayName}
						</ApRadio>
					</RadioWrapper>
					{data ? (
						this.getFilteredColumns().map(dimensionItem => {
							const {
								displayName,
								dimensionName,
								totalCount,
								sampleValues,
							} = dimensionItem;
							const isDisabled =
								totalCount === 0 || totalCount > VALUES_THRESHOLD;

							return (
								<RadioWrapper key={dimensionName} disabled={isDisabled}>
									<ApRadio
										name="columns"
										value={dimensionName}
										checked={
											!!dimension && dimensionName === dimension.dimensionName
										}
										onChange={() => this.changeDimension(dimensionItem)}
										disabled={isDisabled}
									>
										<RadioLabel>
											{this.getHighlightedName(displayName)}
											<HelperText>
												{'('}
												{sampleValues && (
													<React.Fragment>
														{numeral(totalCount).format('0,0')} values{totalCount >
														0
															? ':\u00A0'
															: ''}
														<TextTruncate>
															{sampleValues.filter(Boolean).join(', ')}
														</TextTruncate>
													</React.Fragment>
												)}
												{')'}
											</HelperText>
										</RadioLabel>
									</ApRadio>
								</RadioWrapper>
							);
						})
					) : (
						<LoaderWrapper>
							<ApLoaderDefault loaderText={() => <ApLoaderText />} />
						</LoaderWrapper>
					)}
				</RadioGroup>
			</Wrapper>
		);
	}
}
